import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import close_modal from "./../../../assets/ic_close_wh.svg";

export default function OutboundCallingReportActionModal(props)
{
    return (
        <Modal
            isOpen={props.isOpen}
            onRequestClose={props.toggleModal}
            ariaHideApp={false}
        >
          <ModalContent className="outbound-calling-report-action-modal">
            <div className="modal-header">
                <span className="modal-title">Outbound Calling Report Actions</span>
                <img
                    alt="close"
                    id="Close"
                    src={close_modal}
                    className="close modal-close"
                    onClick={props.toggleModal}
                />
            </div>
            
            <div className={`modal-body spled-container notes-trail-content custom-scrollbar`}>
                <div className="row conv-mt10 conv-ml0">
                    <div className="col-12 conv-pl10">
                        <button 
                            type="button" 
                            className={`lpm-con-btn-filled conv-mr25 conv-pl25 conv-pr25`}
                            onClick={props.generateCallingReport}>
                           Generate 
                        </button>
                    </div>
                    <div className="col-12 conv-pl10 conv-mt20">
                        <input className="form-control-custom" type="file"onChange={props.onOutboundUpload}/>
                    </div>
                    <div className="col-12 conv-mt5">
                        <span className="outbound-hint">Hint:First Upload Ameyo report {" "}</span>  
                        <a 
                            className="outbound-url-link"
                            target="_BLANK"
                            href="https://drive.google.com/drive/u/1/folders/1Yb3jl342B2iZFa1OG0cFDaCKuW3Njw9Y"
                        >
                            Here
                        </a>
                    </div>  
                   
                </div>   
                <div className="row conv-mt10">
                    <div className="col-12 modal-bottom-action conv-mt25">
                        <button 
                            type="button" 
                            className={`lpm-con-btn-filled conv-pl25 conv-pr25 conv-float-right`}
                            onClick={props.uploadOutboundReport}>
                            Upload 
                        </button>
                        <button 
                            type="button" 
                            className={`outbound-con-btn-bordered conv-mr25 conv-float-right`}
                            onClick={props.downloadOutboundUploadLogs}>
                            Log 
                        </button>
                    </div>
                </div>             
            </div>
          </ModalContent>
        </Modal>
      );
}